import React, { useEffect, useState } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'info', visible, onClose, duration = 3000 }) => {
  const [isHiding, setIsHiding] = useState(false);

  useEffect(() => {
    if (visible && duration > 0) {
      const timer = setTimeout(() => {
        setIsHiding(true);
        // 延迟调用 onClose，确保动画完成
        setTimeout(() => {
          onClose();
        }, 300);
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [visible, duration, onClose]);

  const handleClose = () => {
    setIsHiding(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  if (!visible) return null;

  return (
    <div className={`toast-container ${type} ${isHiding ? 'hiding' : ''}`}>
      <div className="toast-content">
        <div className="toast-icon">
          {type === 'success' && '✓'}
          {type === 'error' && '✕'}
          {type === 'warning' && '⚠'}
          {type === 'info' && 'ℹ'}
        </div>
        <div className="toast-message">{message}</div>
        <button className="toast-close" onClick={handleClose}>×</button>
      </div>
    </div>
  );
};

export default Toast; 